import {Component, OnInit, Input, ViewChild, Output, EventEmitter} from '@angular/core';
import { Competition } from 'app/models/competition'
@Component({
  selector: 'app-competition-background',
  templateUrl: './competition-background.component.html',
  styleUrls: ['./competition-background.component.scss']
})
export class CompetitionBackgroundComponent implements OnInit {

  @Input() competition: Competition;
  @Input() disabled: boolean;
  @Input() competituonUploaderType: string;
  @Output() fileError = new EventEmitter<number>();
  @ViewChild('file') file: any;
  public title: string;
  public icon: any;
  public msg: string;
  constructor() {
    this.disabled = false;
  }

  ngOnInit() {
    this.title = (this.competituonUploaderType === 'background') ?
      'Competition Background' : 'Stadium';
      this.msg = (this.competituonUploaderType === 'background') ?
      'Upload Competition Background' : 'Upload Stadium Background';
  }

  onImgChange(event): void {
    if (this.competituonUploaderType === 'background') {
        this.competition.backgroundFile = event.file.name
        this.competition.backgroundUrl = event.file
    } else {
        this.competition.stadiumFile = event.file.name
        this.competition.stadiumUrl = event.file
    }
    this.icon = event.url
  }

  onChange(event) {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      const fileSize = event.target.files[0].size / 1000; // in bytes
      if (fileSize >= 400) {
        this.fileError.emit(fileSize);
        return false;
      }
      this.convertBlobToBase64(file).then(b64 => {
        const reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = (result) => {
          if (file.type.includes('image')) {
            switch (this.competituonUploaderType) {
              case 'background':
                console.log('img', result);
                this.competition.backgroundFile = file.name;
                this.competition.backgroundUrl = file;
                this.icon = b64;
                break;
              case 'stadium':
                console.log('img', result);
                this.competition.stadiumFile = file.name;
                this.competition.stadiumUrl = file;
                this.icon = b64;
                break;
            }
          } else {
            return false
          }
        };
      });

    }
  }

  cancel() {
    this.icon = null;
    if ( this.file ) {
      this.file.nativeElement.value = '';
    }
  }

  convertBlobToBase64 = blob => new Promise((resolve, reject) => {
    const reader = new FileReader;
    reader.onerror = reject;
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.readAsDataURL(blob);
  })
  // TODO Have to change when backend is ready
  onUpload(): void {
    console.log('upload file');
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/competition-background/competition-background.component.ts